import React from 'react';
import { flex } from '@fabric-ui/theme';
import { Box, Divider, Paper, PaperProps } from '@mui/material';
import ClearSelection from './ClearSelection';
import { OptionObject } from './types';

export const MultiSelectPaper = <T,>({
  children,
  value,
  options,
  onClear,
  isRequired,
  isMultiple,
  customActionButton,
  emptyState,
  inputToolbar,
  ...props
}: PaperProps & {
  value?: T | T[] | null;
  options?: OptionObject<T>[];
  onClear?: () => void;
  isRequired?: boolean;
  isMultiple?: boolean;
  customActionButton?: React.ReactNode;
  emptyState?: React.ReactNode;
  inputToolbar?: React.ReactNode;
}) => (
  <Paper {...props}>
    {inputToolbar}
    {children}
    {emptyState}
    {((!isRequired && isMultiple && Array.isArray(value)) || customActionButton) && (
      <Box
        onMouseDown={event => {
          event.preventDefault();
        }}>
        <Divider sx={{ mb: '8px' }} />
        {isMultiple && Array.isArray(value) && (
          <Box sx={{ ...flex.justifyBetweenCenter, p: '0 8px' }}>
            <ClearSelection sx={{ ...flex.row, fontWeight: 600 }} disabled={value.length === 0} onClick={() => onClear?.()} />
            <Box sx={{ fontSize: 12, color: ({ palette }) => palette.colors.neutrals[600] }}>
              {value.length}/{options?.length ?? ''} Values
            </Box>
          </Box>
        )}
        {customActionButton}
      </Box>
    )}
  </Paper>
);
